import { render, staticRenderFns } from "./page-login.vue?vue&type=template&id=aa645620&scoped=true&"
import script from "./page-login.vue?vue&type=script&lang=js&"
export * from "./page-login.vue?vue&type=script&lang=js&"
import style0 from "./page-login.vue?vue&type=style&index=0&id=aa645620&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa645620",
  null
  
)

export default component.exports